import itemPurchaseThread from './components/itemPurchaseThread';
import mroInviteToRfq from './components/mroInviteToRfq';
import countrySelector from './components/countrySelector';

export default {
  search: {
    header: {
      title: 'Cat4MRO Search',
      invite_button: 'Invite to RFQ',
      info_request_button: '  Information Request',
    },
    filters_bar: {
      search_placeholder: 'Search by keywords',
      country_filter: 'Select Country',
      category_placeholder: 'Search category',
      org_placeholder: 'Search organization',
      filter_counter: {
        cp: {
          acronym: 'PC ',
          content: 'similarities with public catalog items',
        },
        mdm: {
          acronym: 'MM ',
          content: 'similarities to items from your materials master', // verificar que mdm se traduzca como materials master
        },
        cr: {
          acronym: 'CR ',
          content: 'similarities with the cross reference catalog items',
        },
      },
    },
    result_table: {
      selection: 'Select Supplier',
      provider: 'Vendor Name',
      tax_provider: 'Vendor Tax',
      description: 'Item Description',
      class: 'Category',
      price: 'Unit Price',
      match: {
        label: 'Match Level',
        match1: 'Very High',
        match2: 'High',
        match3: 'Medium',
        match4: 'Low',
      },
      expand: {
        manufacturer: 'Manufacturer',
        part_number: 'Part Number',
        action: {
          label: 'Action',
          search: 'Search',
        },
      },
      scope: {
        item2: 'P/N:', // sin contexto
        item3: 'Internal Code:',
        item4: 'N° equivalences:',
        item5: 'Centers:', // sin contexto: centers or headquarters
      },
      see: 'See',
      erpCode: 'Código ERP',
      itemName: 'Item Name',
    },
    script: {
      components: {
        ...itemPurchaseThread,
        ...mroInviteToRfq,
        ...countrySelector,
      },
      copySuccessSku: {
        title: 'Internal Code',
        message: 'Correctly copied',
      },
      copyErrorSku: {
        title: 'Internal Code',
        message: 'could not copy',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/buyer/cat4mro/search.js